"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _luxon = require("luxon");

var _chartUtils = require("../../chartUtils");

require("react-vis/dist/style.css");

var _DownloadCsv = _interopRequireDefault(require("../DownloadCsv"));

var _ChartStyles = require("../ChartStyles");

var _BatteryMinMaxChart = require("../BatteryMinMaxChart");

var _InteractionWithBattery = _interopRequireDefault(require("./InteractionWithBattery"));

var _Display = _interopRequireDefault(require("./Display"));

var _Interaction = _interopRequireDefault(require("./Interaction"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _FixedYAxisChart = _interopRequireDefault(require("../FixedYAxisChart"));

var _Scrollable = _interopRequireDefault(require("../Scrollable"));

var _propTypes2 = require("../../constants/propTypes");

var _ChartLoader = _interopRequireDefault(require("../ChartLoader"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Relative = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var DailyChart = function DailyChart(_ref) {
  var batteryCoordinates = _ref.batteryCoordinates,
      coordinatesGroupedByTime = _ref.coordinatesGroupedByTime,
      displayCoordinates = _ref.displayCoordinates,
      endMillis = _ref.endMillis,
      hasBattery = _ref.hasBattery,
      hasConsumption = _ref.hasConsumption,
      isLoading = _ref.isLoading,
      startMillis = _ref.startMillis,
      storageProfile = _ref.storageProfile,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO,
      withBatteryChart = _ref.withBatteryChart,
      internalUsage = _ref.internalUsage;
  var yTickRange = (0, _chartUtils.getMinMaxRangeFromDisplayCoordinates)(displayCoordinates);
  var downloadFields = [{
    label: 'Time',
    value: 'friendlyDate'
  }];

  if (!hasBattery || internalUsage) {
    var solar = {
      label: 'Solar (kWh)',
      value: 'solar'
    };
    downloadFields.push(solar);
  }

  if (hasConsumption || internalUsage) {
    var consumption = {
      label: 'Consumption (kWh)',
      value: 'consumption'
    };
    var exportValue = {
      label: 'Export (kWh)',
      value: 'exportValue'
    };
    var importValue = {
      label: 'Import (kWh)',
      value: 'importValue'
    };
    var selfConsumption = {
      label: 'Self Consumption (kWh)',
      value: 'selfConsumption'
    };
    downloadFields.push(consumption);
    downloadFields.push(exportValue);
    downloadFields.push(importValue);
    downloadFields.push(selfConsumption);
  }

  if (internalUsage) {
    var peer = {
      label: 'Legacy Peer (kWh)',
      value: 'peer'
    };
    var peerV2 = {
      label: 'Peer (kWh)',
      value: 'peerV2'
    };
    var contract = {
      label: 'Contracted (kWh)',
      value: 'contract'
    };
    downloadFields.push(peer);
    downloadFields.push(peerV2);
    downloadFields.push(contract);
  }

  if (hasBattery || internalUsage) {
    var systemProduction = {
      label: 'System Production (kWh)',
      value: 'systemProduction'
    };
    var batteryCharge = {
      label: 'Battery Charge (kWh)',
      value: 'charge'
    };
    var batteryDischarge = {
      label: 'Battery Discharge (kWh)',
      value: 'discharge'
    };
    downloadFields.push(systemProduction);
    downloadFields.push(batteryCharge);
    downloadFields.push(batteryDischarge);
  }

  return /*#__PURE__*/_react["default"].createElement(Relative, null, /*#__PURE__*/_react["default"].createElement(_ChartLoader["default"], {
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(_FixedYAxisChart["default"], {
    hasNoData: false,
    yTickRange: yTickRange
  }), /*#__PURE__*/_react["default"].createElement(_Scrollable["default"], null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartLeft, {
    "data-tour": "chart-area"
  }, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
    displayCoordinates: displayCoordinates,
    hasBattery: hasBattery,
    isLoading: isLoading,
    timeZone: timeZone,
    viewEndISO: viewEndISO,
    viewStartISO: viewStartISO
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, withBatteryChart && hasBattery ? /*#__PURE__*/_react["default"].createElement(_InteractionWithBattery["default"], {
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    endMillis: endMillis,
    hasBattery: hasBattery,
    startMillis: startMillis,
    timeZone: timeZone
  }) : /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    endMillis: endMillis,
    hasBattery: hasBattery,
    startMillis: startMillis,
    timeZone: timeZone
  }))), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartRight, null, /*#__PURE__*/_react["default"].createElement(_DownloadCsv["default"], {
    hideMobile: true,
    data: Object.values(coordinatesGroupedByTime).sort(_chartUtils.sortCoordinatesDescending).map(function (row) {
      return _objectSpread({
        friendlyDate: _luxon.DateTime.fromMillis(row.x, {
          zone: timeZone
        }).toISO()
      }, row);
    }),
    fields: downloadFields,
    fileName: "Daily Interval"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: {
      height: 31,
      width: 31
    },
    name: "DownloadIcon"
  })))), withBatteryChart && hasBattery && /*#__PURE__*/_react["default"].createElement(_ChartStyles.BatteryPercentageChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_BatteryMinMaxChart.BatteryMinMaxHeader, {
    storageProfile: storageProfile
  }), /*#__PURE__*/_react["default"].createElement(_BatteryMinMaxChart.BatteryMinMaxDisplay, {
    batteryCoordinates: batteryCoordinates,
    endMillis: endMillis,
    isLoading: isLoading,
    startMillis: startMillis,
    timeZone: timeZone
  }))), withBatteryChart && hasBattery && /*#__PURE__*/_react["default"].createElement(_FixedYAxisChart["default"], {
    hasNoData: false,
    tickValues: ['0', '50', '100'],
    handleTickFormat: function handleTickFormat(t) {
      return "".concat(t, " %");
    },
    chartHeight: "100px",
    yTickRange: [0, 100],
    bottom: "0"
  }));
};

DailyChart.propTypes = {
  batteryCoordinates: _propTypes["default"].shape({
    maxCoordinates: _propTypes2.coordinatePropTypes,
    minCoordinates: _propTypes2.coordinatePropTypes,
    areaCoordinates: _propTypes2.coordinatePropTypes
  }),
  coordinatesGroupedByTime: _propTypes2.groupedCoordinatePropTypes,
  displayCoordinates: _propTypes["default"].shape({
    batteryChargeCoordinates: _propTypes2.coordinatePropTypes,
    batteryDischargeCoordinates: _propTypes2.coordinatePropTypes,
    consumptionCoordinates: _propTypes2.coordinatePropTypes,
    contractCoordinates: _propTypes2.coordinatePropTypes,
    estimatedSolarCoordinates: _propTypes2.coordinatePropTypes,
    exportCoordinates: _propTypes2.coordinatePropTypes,
    peerCoordinates: _propTypes2.coordinatePropTypes,
    peerV2Coordinates: _propTypes2.coordinatePropTypes,
    selfConsumptionCoordinates: _propTypes2.coordinatePropTypes,
    solarCoordinates: _propTypes2.coordinatePropTypes,
    systemProductionCoordinates: _propTypes2.coordinatePropTypes
  }),
  endMillis: _propTypes["default"].number.isRequired,
  hasBattery: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  startMillis: _propTypes["default"].number.isRequired,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }),
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired,
  withBatteryChart: _propTypes["default"].bool,
  hasConsumption: _propTypes["default"].bool,
  internalUsage: _propTypes["default"].bool
};
DailyChart.defaultProps = {
  batteryCoordinates: {
    maxCoordinates: [],
    minCoordinates: [],
    areaCoordinates: []
  },
  coordinatesGroupedByTime: {},
  displayCoordinates: {},
  hasBattery: false,
  isLoading: false,
  storageProfile: {},
  timeZone: 'local',
  withBatteryChart: false,
  hasConsumption: false,
  internalUsage: false
};
var _default = DailyChart;
exports["default"] = _default;